import { render, staticRenderFns } from "./customer_scorecard.vue?vue&type=template&id=e01cf8b4&scoped=true&"
import script from "./customer_scorecard.vue?vue&type=script&lang=js&"
export * from "./customer_scorecard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e01cf8b4",
  null
  
)

export default component.exports